export default __webpack_public_path__ + "static/benefitImg-319964ef287f55bc5946993041af5cdf.png";